<template>
  <div class="login-page">
    <div class="login-card">
      <div class="content">
        <div class="title">企业微信登录</div>
        <p>请使用手机企业微信扫描下方二维码</p>
        <div id="wxqr-container"></div>
        <div class="rakumart">西班牙RAKUMART-订单系统</div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.generateQrCode();
  },
  beforeDestroy() {
    this.clearQrCode();
  },
  methods: {
    // 生成企业微信登录二维码
    generateQrCode() {
      this.clearQrCode();

      let that = this;
      this.wwLogin = ww.createWWLoginPanel({
        params: {
          login_type: 'CorpApp',
          appid: 'ww79e73acf2785a242',
          agentid: '1000064',
          redirect_uri: 'https://manage.rakumart.com',
          redirect_type: 'callback',
        },
        onCheckWeComLogin({ isWeComLogin }) {
          console.log(isWeComLogin);
        },
        onLoginSuccess({ code }) {
          location.href = 'https://spain.rakumart.es/#/login?code=' + code
        },
        onLoginFail(err) {
          console.log(err, '失败');
        },
      });

      this.$nextTick(() => {
        const container = document.getElementById('wxqr-container');
        if (container && this.wwLogin && this.wwLogin.el) {
          container.appendChild(this.wwLogin.el);
        }
      });
    },
    // 清理二维码
    clearQrCode() {
      const container = document.getElementById('wxqr-container');
      const iframe = container ? container.querySelector('iframe') : null;
      if (container && iframe) {
        container.removeChild(iframe);
      }
      this.wwLogin = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

.login-card {
  width: 420px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
}

.content {
  color: #1A1A1A;

  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
  }

  p {
    margin-bottom: 30px;
    text-align: center;
    font-size: 16px;
    color: #666;
  }

  .row {
    margin: 0 20px 30px;

    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin: 0 10px;
      vertical-align: middle;
    }

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .btn {
    text-align: center;
    margin-top: 30px;
  }

  .rakumart {
    margin-top: 20px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  #wxqr-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    min-height: 200px;
  }

  .back-link {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
